import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(lang_config);

    /** @ngInject */
    function lang_config($translateProvider) {
        $translateProvider
            .preferredLanguage('pl')
            .useSanitizeValueStrategy(null);
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/translations/_translation.config.ts